<template>
  <view class="dialog-show-close-demo">
    <cube-button  bind:click="onClickDialog">Dialog - with close icon</cube-button>
    <cube-dialog

      wx:ref="dialogWithCloseIcon"
      show-close="{{ true }}"
      icon="alert"
      cancel-btn="取消"
      confirm-btn="确认"
    >
      <view slot="title">测试标题</view>
      <view class="dialog-show-close-content" slot="content">测试content</view>
    </cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  methods: {
    onClickDialog () {
      const dialogRef = this.$refs.dialogWithCloseIcon
      dialogRef.show()
    }
  }
})
</script>

<style lang="stylus">
.dialog-show-close-content
  text-align center
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>
